import { render } from "./AmoCrmWhatsappChat.vue?vue&type=template&id=cb8f0372&scoped=true&ts=true"
import script from "./AmoCrmWhatsappChat.vue?vue&type=script&lang=ts"
export * from "./AmoCrmWhatsappChat.vue?vue&type=script&lang=ts"

import "./AmoCrmWhatsappChat.vue?vue&type=style&index=0&id=cb8f0372&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8f0372"]])

export default __exports__